<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      align="start"
      class="fill-height ma-0"
    >
      <v-col
        cols="12"
      >
        <span class="subtitle-1">O método de pagamento escolhido foi <b>Boleto bancário</b></span>
      </v-col>
      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          color="secondary"
          outlined
          large
          :href="postPayUrl"
          target="_blank"
        >
          <v-icon class="mr-2">mdi-barcode</v-icon>
          Visualizar boleto
        </v-btn>
      </v-col>
      <v-col
        cols="12"
      >
        <span class="subtitle-1" v-html="infoText"></span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {TRANSACTION_TYPE} from "../../helpers/transactions/constants"
  import {mapGetters} from "vuex"
  import {GET_POST_PAYMENT_DATA} from "../../store/modules/post-payment"

  export default {
    name: "PostPayMainInfo",
    computed: {
      postPayUrl() {
        if (!this.postPaymentData) return ""
        return this.postPaymentData["transaction"]["boleto_bancario"]["url_boleto"]
      },
      infoText() {
        if (!this.postPaymentData) return ""

        let infoText = ""
        switch (this.postPaymentData["transaction"]["ab_transaction_type"]) {
          case TRANSACTION_TYPE.IMAGE_PROCESSING:
            infoText = `O processamento ocorrerá somente após a confirmação do pagamento, que poderá demorar até <b>dois\n` +
              `dias úteis</b> para acontecer.`
            break
          case TRANSACTION_TYPE.SUBSCRIPTION:
          case TRANSACTION_TYPE.SUBSCRIPTION_UPDATE:
            infoText = `A assinatura ficará ativa somente após a confirmação do pagamento, que poderá demorar até <b>dois\n` +
              `dias úteis</b> para acontecer.`
            break
          case TRANSACTION_TYPE.POST_PROCESSING:
            infoText = `A análise agronômica ocorrerá somente após a confirmação do pagamento, que poderá demorar até <b>dois\n` +
              `dias úteis</b> para acontecer.`
            break
          case TRANSACTION_TYPE.PHYSICAL_PRODUCT:
            infoText = "Após aprovação do pagamento, você receberá por e-mail a confirmação de inscrição na Turma Phantom."
            break
          default:
            break
        }
        return infoText
      },
      ...mapGetters({
        postPaymentData: GET_POST_PAYMENT_DATA,
      }),
    },
  }
</script>

<style scoped>

</style>
